import React from "react";

import {
  formatDate,
} from "../utils/publicOffer.utils";


const PublicOfferDetails = ({
  publicOffer,
}) => {

  const offer =
    publicOffer?.offer;

  const client =
    publicOffer?.client;

  const query =
    publicOffer?.query;


  return (
    <section className="public-offer-details">

      <div className="public-offer-section-header">

        <h2>
          Offer Details
        </h2>

        <p>
          Please review the proposal
          details before accepting.
        </p>

      </div>


      <div className="public-offer-details-grid">

        <div className="public-offer-detail-card">

          <span>
            Client
          </span>

          <strong>
            {client?.name || "-"}
          </strong>

          {client?.companyName && (
            <small>
              {client.companyName}
            </small>
          )}

        </div>


        <div className="public-offer-detail-card">

          <span>
            Email
          </span>

          <strong>
            {client?.email || "-"}
          </strong>

        </div>


        <div className="public-offer-detail-card">

          <span>
            Phone
          </span>

          <strong>
            {client?.phone || "-"}
          </strong>

        </div>


        <div className="public-offer-detail-card">

          <span>
            Valid Until
          </span>

          <strong>
            {formatDate(
              offer?.validUntil
            )}
          </strong>

        </div>

      </div>


      {query && (
        <div className="public-offer-query">

          <h3>
            Requirement
          </h3>

          {query.subject && (
            <strong>
              {query.subject}
            </strong>
          )}

          {query.message && (
            <p>
              {query.message}
            </p>
          )}

        </div>
      )}


      {offer?.notes && (
        <div className="public-offer-notes">

          <h3>
            Notes
          </h3>

          <p>
            {offer.notes}
          </p>

        </div>
      )}

    </section>
  );
};


export default PublicOfferDetails;
